<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.superAmbassador.create")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineSuperAmbassadorForm :APIbaseURL="APIbaseURL" :superAmbassador="superAmbassador" :adminMode="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineSuperAmbassadorForm } from 'aveine-super-ambassador'
import { SuperAmbassador } from 'aveine-toolbox'

export default {
  data () {
    return {
      superAmbassador: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Create',
  components: {
    AveineSuperAmbassadorForm
  },
  async created() {
    this.superAmbassador = await SuperAmbassador.new();
    this.superAmbassador.$isNew = true;
    this.dataLoaded = true
  },
}
</script>
